import { createI18n } from '@learnforge/i18n';
import { locales, type AlgebraKey } from './locales';

export const i18n = createI18n<AlgebraKey>({
  gameId: 'algebra',
  locales,
});
